import { useCallback, useMemo } from "react";
import { EditNichePopup } from "./EditNichePopup";
import { EDIT_NICHE_FIELDS, getFieldsWithValues } from "./helpers";
import { showNotification } from "@/components/notifications/Notifications";
import { IEditNichePopupContainerProps } from "@/common/buses/popups/popup-types";
import { onCloseEditNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { INicheForm } from "components/popups/NicheForm/NicheForm";
import { useNicheFormState } from "../NicheForm/hooks/useNicheFormState";
import { PREFERENCES_CHECKBOXES } from "../NicheForm/constants";
import { apiNiches } from "@/common/services";

export const EditNichePopupContainer: React.FC<IEditNichePopupContainerProps> = ({ niche }) => {
  const preferences = useMemo(() => {
    return PREFERENCES_CHECKBOXES.map((pref) => ({
      ...pref,
      isChecked: !!niche?.preferences?.includes(pref.name)
    }));
  }, [niche]);

  const {
    avatarTicketId,
    bannerTicketId,
    prefOptions,
    tags,
    onSetPreferences,
    handleAvatarTicketId,
    handleBannerTicketId,
    onTagsChange
  } = useNicheFormState(preferences, niche.tags ?? []);

  const onSubmit = async (data: INicheForm) => {
    try {
      await apiNiches.editNiche({
        id: niche.id,
        description: data.description,
        image: avatarTicketId || null,
        banner: bannerTicketId,
        preferences: prefOptions.filter((pref) => pref.isChecked).map((pref) => pref.name),
        tags: tags,
      });

      handleClose();
      showNotification({
        title: "Successfully Updated",
        variant: "success"
      });
    } catch (e) {
      console.error(e);
      showNotification({
        title: "Something went wrong. Please try later",
        variant: "error"
      });
    }
  };

  const handleClose = useCallback(() => {
    onCloseEditNichePopup();
  }, []);

  const nicheValues = {
    name: niche.name,
    description: niche.description,
  };

  const nicheFields = getFieldsWithValues(EDIT_NICHE_FIELDS, nicheValues);

  return (
    <EditNichePopup
      nicheFields={nicheFields}
      onClose={handleClose}
      isOpen={true}
      onSubmit={onSubmit}
      preview={niche.thumbnail}
      banner={niche.cover}
      handleAvatarTicketId={handleAvatarTicketId}
      handleBannerTicketId={handleBannerTicketId}
      onSetPreferences={onSetPreferences}
      onTagsChange={onTagsChange}
      tags={tags}
      avatarTicketId={avatarTicketId}
      bannerTicketId={bannerTicketId}
      prefOptions={prefOptions}
    />
  );
};
